<template>
<div>
  <img id="bg" alt="">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-7 col-lg-5">
        <div class="login">

          <div id="img">
            <img class="image_stars" src="../../assets/fern_light_green.jpg"  alt="logo">
            <img class="image_logo" src="../../assets/pura_logo.png"  alt="logo_text">
          </div>


        <form @submit.prevent>
          <div class="login-form-container ">

            <h2 class="portal-title">Client Sign Up</h2>
            
            <div class="d-flex justify-content-center"><div v-if="loading" class="spinner-border text-danger" style="margin-bottom: 15px" role="status"></div></div>

            <div>
              <b-form-input  type="text" class="signup-control" id="FirstName" placeholder="Ingoa tuatahi (First Name) *" v-model="firstName"  required/>
            </div>

            <div>
              <b-form-input type="text" class="signup-control" id="LastName" placeholder="Ingoa whanau (Surname) *" v-model="lastName" required/>
            </div>

            <div>
              <b-form-input type="email" class="signup-control" id="email" placeholder="Tomo īmēra (Enter email) *" v-model="email" required/>
            </div>

            <div>
              <b-form-input type="password" class="signup-control" id="MyPassword" placeholder="Tomo Kupuhipa (Enter password) *" v-model="password" password-reveal required/>
            </div>

            <div class="text-danger text-center" v-if="this.passwordError"><p>{{this.passwordErrorMsg}}</p></div>  

            <div>
              <b-form-input type="password" class="signup-control" id="ConfirmPassword" placeholder="Confirm password *" v-model="confirmedPassword" password-reveal required/>
            </div>

          
            <div class="text-danger text-center" v-if="this.confirmedPasswordError"><p>{{this.confirmedPasswordErrorMsg}}</p></div>  

            <div class="text-danger text-center" v-if="this.error"><p>{{this.errorMessage}}</p></div>  

            <div class="form-group">
              <b-button :disabled="loading" class="btn btn-block form-button" id="button-login" type="button" @click="this.$router.push({name: 'clientLogin'})">Back</b-button>
              <b-button :disabled="loading" class="btn btn-block form-button" id="button-signup" type="submit" @click="signUp()">Sign Up</b-button>
            </div>
            </div>
        </form>
          <div class="form-group" v-if="this.passwordError || this.confirmedPasswordError">
            <button :disabled="loading" class="btn btn-block" @click="showPassword()">Reveal Passwords</button>
            
            </div>
          </div>
          
        </div>
      </div>
  </div>
</div>

</template>

<script>
import api from "@/services/api/api";


const SignUpComponent = {
  name: "signup",
  data() {
    return {
      error: null,
      email: "",
      password: "",
      confirmedPassword:"",
      lastName:"",
      firstName:"",

      anyErrorMessage: [],
      errorMessage: "",

      loading: false,

      passwordError: false,
      passwordErrorMsg: null,

      confirmedPasswordError: false,
      confirmedPasswordErrorMsg: null,

    };
  },

  
  /**
   * Clear the localStorage (logs out the user) and set isLogged to false.
   */
  created() {
    this.isLogged = false;
    sessionStorage.clear();
  },

  methods: {
    /**
     * Checks that the email provided contains the right symbols and order.
     * Not currently called as users have not been set up. 
     */
    validateEmail() {
      var emailRegEx = /[a-zA-Z0-9]+@[a-zA-Z0-9]+.[a-zA-Z]+/;

      if (!emailRegEx.test(this.email)) {
        this.errorMessage = "Wrong Email Format"
        this.error = true;
        console.log("Bad Email")
        return false
      } else {
        console.log("Good Email")
        return true
      }
    },

    /**
     * Check if password is at least 8
     * Check if password and confirmed password are match
     */
    comparePassword(){

      var passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
      console.log("Password Test")
      console.log(this.password, this.confirmedPassword)

      if (!passwordRegEx.test(this.password)) {
        this.passwordError = true;
        this.passwordErrorMsg = 'Must be at least eight characters, at least one uppercase letter, one lowercase letter and one number!';
        return false
      } 

      if(this.password != this.confirmedPassword){
        console.log("passwords dont match")
        this.confirmedPasswordError = true;
        this.confirmedPasswordErrorMsg = "Given passwords do not match"
        return false
      } else{
        console.log("passwords do match")
        return true
      }
    },



    /**
     * Reveals the users password field in plain text
     */
    showPassword() {
      var x = document.getElementById("MyPassword");
      var y = document.getElementById("ConfirmPassword");
      if (x.type === "password" & y.type === "password") {
        x.type = "text";
        y.type = "text";
      } else {
        x.type = "password";
        y.type = "password";
      }
    },


    /**
     * Attempts to sign in the user. Check that the email matches the required regex. Additionally checks if the passwords 
     * match the requirements and that the passwords entered match eachother
     * 
     * Submits an API request to create the user.
     */
    signUp() {

      this.resetErrorMessage()
      
      if(this.validateEmail() && this.comparePassword()){
        if (!this.passwordError && !this.error && !this.confirmedPasswordError) {
          this.loading = true
          this.info = {
            "email": this.email,
            "password": this.password,
            "confirmedPassword": this.confirmedPassword,
            "lastName": this.lastName,
            "firstName": this.firstName,
          }
          console.log(this.info)
          api.users.signUp(this.info)
              .then(res => {
                  sessionStorage.setItem("firstName", res.data.firstName);
                  sessionStorage.setItem("email", res.data.email);
                  sessionStorage.setItem("lastName", res.data.lastName)
                  
                  sessionStorage.setItem("clientId", res.data.clientId)

                  this.error = false
                  this.$router.push({name: 'home'})
              })
              .catch(err => {
                this.error = true
                this.loading = false
                this.errorMessage = err.response.statusText
            });
        } else {
          console.log(this.error, this.passwordError, this.confirmedPasswordError)
        }
      }
        
      },


      /**
       * Resets the error messages
       */
      resetErrorMessage() {
        this.errorMessage = ""

        this.loading = false
        this.error = false

        this.passwordError = false
        this.passwordErrorMsg = null

        this.confirmedPasswordError = false
        this.confirmedPasswordErrorMsg =  null
      },
    },
}

export default SignUpComponent;
</script>

<style scoped>
@import '../../assets/styles/signup.css';

</style>


